// frontend/src/components/Button.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { buttonClasses } from './buttonClasses';
import './Button.css';

export default function Button({
  variant = 'secondary',
  size = 'md',
  iconOnly = false,
  fullWidth = false,
  to = null,
  href = null,
  target,
  rel,
  loading = false,
  loadingText = 'Loading…',
  type = 'button',
  disabled = false,
  className = '',
  children,
  ...rest
}) {
  const cls = buttonClasses({ variant, size, iconOnly, fullWidth, className });
  const content = loading ? loadingText : children;

  if (to) {
    return (
      <Link to={to} className={cls} aria-disabled={disabled || loading ? 'true' : undefined} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={cls} aria-disabled={disabled || loading ? 'true' : undefined} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button type={type} className={cls} disabled={disabled || loading} {...rest}>
      {content}
    </button>
  );
}
